var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "circle-2",
    clipPath: "url(#clip0_1003_1645)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16 0C7.1625 0 0 7.1625 0 16C0 24.8375 7.1625 32 16 32C24.8375 32 32 24.8375 32 16C32 7.1625 24.8375 0 16 0ZM16 30C8.28125 30 2 23.7188 2 16C2 8.28125 8.28125 2 16 2C23.7188 2 30 8.28125 30 16C30 23.7188 23.7188 30 16 30ZM21 22H13.6562L19.1106 17.2188C21.275 15.32 21.5256 12.1012 19.6839 9.89375C18.7676 8.79625 17.4789 8.13 16.0539 8.01875C14.6195 7.89375 13.2514 8.3625 12.1776 9.30375L11.1 10.2437C10.6313 10.6125 10.6438 11.2375 11.0063 11.6562C11.3688 12.075 12 12.1125 12.4187 11.75L13.4981 10.8069C14.1625 10.225 15.0125 9.95625 15.9 10.0125C16.7825 10.0828 17.5819 10.4949 18.15 11.1763C19.2919 12.5456 19.1356 14.5394 17.7945 15.7175L10.3383 22.2488C10.0247 22.5241 9.91444 22.9638 10.0619 23.3525C10.2125 23.7438 10.5813 24 11 24H21C21.5527 24 22 23.5527 22 23C22 22.4473 21.55 22 21 22Z",
    fill: "#757575"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1003_1645"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg2);
export default __webpack_public_path__ + "static/media/2.0a5d0a89beaf269f3f21728442b1212e.svg";
export { ForwardRef as ReactComponent };